<h1 mat-dialog-title>{{data.title | translate}}</h1>
<div mat-dialog-content>
  {{data.message | translate}}
</div>
<div mat-dialog-actions align="center">
  <button mat-button mat-dialog-close cdkFocusInitial>
    <mat-icon>close</mat-icon>
    <span>{{'common.button.close' | translate}}</span>
  </button>
</div>